export default {
  'Age': 'Age',
  'Gender': 'Gender',
  'Demographic': 'Demographic',
  'Device': 'Device',
  'Location': 'Location',
  'MultimediaAd': 'MultimediaAd',
  'NativeAd': 'NativeAd',
  'OriginalDevice': 'OriginalDevice',
};
